import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoOrganizacionPrincipal from "../../catalogos/catalogoOrgaPrincipal";
import { validaSoloNumero } from "../../util/varios";

export const ActualizarEfiscal = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mostrar3, setMostrar3] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idefiscal: "",
    descriptor: "",
    anio: "",
    observaciones: "",
    statusorg: "",
    statuspresup: "",
    statuspuc: "",
    statuscat: "",
    idorganizacion: "",
    activo: false,
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdd = useRef();
  const txtDescrip = useRef();
  const txtAnio = useRef();
  const txtObser = useRef();
  const txtStatuscat = useRef();
  const txtStatusor = useRef();
  const txtStatuspre = useRef();
  const txtStatuspuc = useRef();
  const txtCodigo = useRef();
  const txtDescripor = useRef();

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtAnio.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Año del Ejercicio Fiscal",
        icono: "informacion",
      });
      sigue = false;
      txtAnio.current.focus();
    } else if (txtDescrip.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Descripción del Ejercicio Fiscal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (txtObser.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Observación del Ejercicio Fiscal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtObser.current.focus();
    } else if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Organizacion no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtDescripor.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Organización no Existe o Esta Vacia",
        icono: "informacion",
      });
      sigue = false;
      txtDescripor.current.focus();
    } else if (txtStatusor.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Estatus de la Organización",
        icono: "informacion",
      });
      sigue = false;
      txtStatusor.current.focus();
    } else if (txtStatuspuc.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Estatus del PUC",
        icono: "informacion",
      });
      sigue = false;
      txtStatuspuc.current.focus();
    } else if (txtStatuspre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Estatus del Presupuesto",
        icono: "informacion",
      });
      sigue = false;
      txtStatuspre.current.focus();
    } else if (txtStatuscat.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Estatus de la Categoria",
        icono: "informacion",
      });
      sigue = false;
      txtStatuscat.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarefiscal/${operacion}`;
    let body;
    setActivate(true);

    body = {
      nid: parseInt(txtIdd.current.value),
      des: txtDescrip.current.value.trim(),
      nanio: txtAnio.current.value.trim(),
      obser: txtObser.current.value.trim(),
      staorg: txtStatusor.current.value.trim(),
      stapre: txtStatuspre.current.value.trim(),
      stapuc: txtStatuspuc.current.value.trim(),
      stacat: txtStatuscat.current.value.trim(),
      idorg: parseInt(txtCodigo.current.value),
      actv: false,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idefiscal: "",
      descriptor: "",
      anio: "",
      observaciones: "",
      statusorg: "",
      statuspresup: "",
      statuspuc: "",
      statuscat: "",
      idorganizacion: "",
      activo: false,
    });
    setActivate(false);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const catalogoOrg = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleAceptaCatalogoOrg = (idorganizacion, nombre) => {
    setMostrar3(false);
    txtCodigo.current.value = idorganizacion;
    txtDescripor.current.value = nombre;
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.fiscal);
        } else {
          txtCodigo.current.value = "";
          txtDescripor.current.value = "";
          txtStatuscat.current.value = "";
          txtStatusor.current.value = "";
          txtStatuspre.current.value = "";
          txtStatuspuc.current.value = "";
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Agregar Ejercicio Fiscal."
              : operacion === 2
              ? "Editar Ejercicio Fiscal."
              : operacion === 3
              ? "Eliminar Ejercicio Fiscal."
              : "Consultar Ejercicio Fiscal."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <CatalogoOrganizacionPrincipal
          show={mostrar3}
          onHideCancelar={handleCancelara}
          onHideAceptaCatOrg={handleAceptaCatalogoOrg}
        />
        <Dimmer active={activate} />
        <div className="container-fluid rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">Datos</legend>

                <div className="input-group py-1 input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    ref={txtIdd}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={values ? values.idefiscal.trim() : ""}
                    id="inputCedula"
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-2 ml-auto">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Año:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control text-center"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    maxLength="4"
                    onChangeCapture={handleInputNumChange}
                    defaultValue={values ? values.anio : ""}
                    ref={txtAnio}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Descripción:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control text-uppercase"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtDescrip}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={values ? values.descriptor.trim() : ""}
                    id="inputDireccion"
                  />
                </div>
                <div className="input-group py-1 input-group-sm col-sm-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Observaciones:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control text-uppercase"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtObser}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={values ? values.observaciones.trim() : ""}
                    id="inputDireccion"
                  />
                </div>
              </fieldset>

              <div className="col-md-12 py-2"></div>

              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">
                  Datos de la Organización
                </legend>

                <div className="container row m-0">
                  <div className="input-group py-1 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Código:
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtCodigo}
                      /* onKeyUp={validarUnidadEjecutora} */ defaultValue={
                        props.organiza ? props.organiza.idorganizacion : ""
                      }
                      className="form-control col-4 px-2"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputCedula"
                    />
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClick={catalogoOrg}
                      className="btn btn-sm  btn-info"
                    >
                      <i className="fa fa-search"></i>{" "}
                    </button>
                  </div>
                </div>

                <div className="container row m-0">
                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Descripción:
                    </label>
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      disabled={true}
                      ref={txtDescripor}
                      defaultValue={
                        props.organiza ? props.organiza.nombre.trim() : ""
                      }
                      placeholder="Descripción de la Unidad Ejecutora"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputDireccion"
                    />
                  </div>
                </div>
                <div className="container row m-0">
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Estatus Organización:
                    </label>
                    <select
                      className="form-select text-center"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtStatusor}
                      aria-label="Default select example "
                      defaultValue={props.fiscal ? props.fiscal.statusorg : ""}
                      id="inputSexo"
                    >
                      <option value="">--Seleccione--</option>
                      <option value="222">CREADA</option>
                      <option value="111">POR CREAR</option>
                    </select>
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Estatus del Puc:
                    </label>
                    <select
                      className="form-select text-center"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtStatuspuc}
                      aria-label="Default select example "
                      defaultValue={props.fiscal ? props.fiscal.statuspuc : ""}
                      id="inputSexo"
                    >
                      <option value="">--Seleccione--</option>
                      <option value="22">CARGADA</option>
                      <option value="11">POR CARGAR</option>
                    </select>
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Estatus del Presupuesto:
                    </label>
                    <select
                      className="form-select text-center"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtStatuspre}
                      aria-label="Default select example "
                      defaultValue={
                        props.fiscal ? props.fiscal.statuspresup : ""
                      }
                      id="inputSexo"
                    >
                      <option value="">--Seleccione--</option>
                      <option value="1">POR APROBAR</option>
                      <option value="2">APROBADO</option>
                      <option value="3">CERRADO</option>
                    </select>
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Estatus de la Categoria:
                    </label>
                    <select
                      className="form-select text-center"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtStatuscat}
                      aria-label="Default select example "
                      defaultValue={props.fiscal ? props.fiscal.statuscat : ""}
                      id="inputSexo"
                    >
                      <option value="">--Seleccione--</option>
                      <option value="32">CARGADA</option>
                      <option value="31">POR CARGAR</option>
                    </select>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/presupuesto/modalActualizarEfiscal.js